export const MESSAGE = {
    blog:"Blog",
    home:"Home",
    createReview:"Write a Review",
    manageMyNonprofit:"Manage My Nonprofit",
    manageMyAccount:"Manage My Account",
    logout:"Logout",
    login:"Login",
    signUp:"Sign Up",
    donateNowBtn:"Donate Now",
    removeFavorite:"Remove Favorite",
    topRatedNonprofits:"Top Rated Nonprofits", 
    forNonprofits:"For Nonprofits",
    aboutUs:"About Us",
    quickLinks:"Quick Links",
    contactFaqs:"Contact & FAQs",
    solutions:"Solutions",
    communityConnect:"Community Connect",
    apiAndDataIntegration:"API & Data Integration",
    getInvolved:"Get Involved",
    emptyBasketMessage:"You can add multiple charity donations to your cart and then check out in one easy transaction!",
    donateToNonprofits:"Donate to Nonprofits",
    findMoreNonprofitsBtn:"Find more nonprofits",
    noDonationInBasket:"You have no donations in your Giving Basket!",
    volunteer:"Volunteer",
    discoverTopCauses:"Discover Top Causes",
    exploreTopCities:"Explore Top Cities", 
    linkToUs:"Link to Us",
    publishFundraiser:"Republish Fundraiser",
    advertising:"Advertising",
    topRatedList:"Top-Rated List",
    nonprofitsAndCharitiesNearMe:"Nonprofits and Charities Near Me",
    aboutTopRatedAwards:"About Top-Rated Awards",
    topRatedAwards:"Top-Rated Awards",
    topRatedBadge:"Top-Rated Badge",
    donateGreatNonprofits:"Donate to GreatNonprofits",
    connectWithUs:"Connect with Us",
    givingGuides:"Giving Guides",
    topCities:"Top Cities",
    topCauses:"Top Causes",
    nominate:"Nominate",
    claimYourNonprofit:"Claim Your Nonprofit",
    inviteReviews:"Invite Reviews",
    showcaseReviews: "Showcase Reviews",
    
    reviews:"Reviews",
    topRatedListTitle: (count:number,cause:string,location:string) => `${count} Top-Rated Nonprofits in ${cause} From ${location}`,
    viewNonprofitsBy:"View Nonprofits by",
    theGreatNonprofitsBadge:"The GreatNonprofits Badge",
    getDonations:"Get Donations",
    Donations:"Donations",
    nonprofitSuccessStories:"Nonprofit Success Stories",
    elliottAdvocacy:"Elliott Advocacy",
    ladyFreethinker:"Lady Freethinker",
    aboutGreatNonprofit:"About GreatNonprofit",
    boardMembers:"Board Members",
    team:"Team", 
    advisoryBoard:"Advisory Board",
    ourStory:"Our Story",
    press:"Press",
    donateToUs:"Donate to Us",
    ourSupporters:"Our Supporters",
    careers:"Careers",
    contactUs:"Support/ Contact Us",
    endorsements:"Endorsements",
    sponsors:"Sponsors",
    bannerTitle: "DONATE FOR MEANINGFUL IMPACT IN YOUR COMMUNITY",
    bannerSubTitle: "Give to All Your Favorite NonProfits In One Quick, Easy & Secure Transaction!",
    allState: "All USA",
    search:"Search",
    nearByCities:"Nearby cities",
    getOurLatestNews:"Get Our Latest News",
    submitBtn:"Submit",
    cancelBtn:"Cancel",
    invalidErrors: (name: string) => `Please enter a valid ${name}`,
    passwordInvalidErrors: (field:string) => `${field} must match the password`,
    maxLengthErrors: (name: string, length: number) =>
        `Must be ${length} characters or less Required for ${name}`,
    
    minDigitErrors: (name: string, length: number) =>
        `Must be ${length} digit or more Required for ${name}`,
    maxDigitErrors: (name: string, length: number) =>
        `Must be ${length} digit or less Required for ${name}`,
    minLengthErrors: (name: string, length: number) =>
        `Must be ${length} characters or more Required for ${name}`,
    requiredErrors: (name: string) => `${name} is Required`,
    passwordValidation: "Password must contains special character, uppercase, number & minimum 8 letters",
    forgotPassword:"Forgot Password?",
    emailLabel: "Email address",
    confirmPasswordLabel:"Confirm password",
    confirmPasswordSame:"Both password not matched",
    passwordLabel: "Password",
    tokenLocal: "token",
    development:"development",
    nonprofitsText: (name:string) => `Nonprofits Near ${name}, CA`,
    seeMoreButtonText:"See More Results",
    notFoundTitle: (city?:string,category?:string) => `We couldn't find ${category} nonprofits near ${city}`,
    viewAll: "View All",
    notFoundCategoryTitle: "Some of Non-Profits You Might Want to Explore",
    homeBlogTitle: "Latest Articles",
    visitBlog: "Visit Blog",
    helpPeopleSubtitle: "Help People Now",
    helpPeopleTitle: "We Help Poor Children to Get Life Better.",
    helpPeopleText: "Helping underprivileged children access education, mentorship, and opportunities to build a brighter, more sustainable future.",
    helpPeopleListItem: "Providing access to education and resources.",
    helpPeopleListItem2: "Offering mentorship to develop essential skills.",
    helpPeopleListItem3: "Creating opportunities for lasting change.",
    footerText: "These stories are submitted by people who know you best your clients, donors, volunteers, and others all those who have experienced the impact of nonprofit work up close!",
    peopleHelpText: "Nonprofits Campaigns are Running",
    SearchTitle:"Palomacy Pigeon & Dove Adoptions",
    imageTitle:"Great Nonprofits Top-Rated Guide",
    detailAwardTitle:"Great Nonprofits Top-Rated Awards",
    loginTitle: "GreatNonprofits has over...",
    loginFormTitle: "Log In To Your Account",
    passwordResetFormTitle: "Password Reset",
    orLoginWithText: "Or Login With",
    doNotHaveAccountText: "Don't have an Account?",
    alreadyHaveAccountText: "Already have an Account?",
    joinOurCommunity: "Sign Up & Join Our Community",
    myPersonalFundraisers:"My Personal Fundraisers",
    southOfMarket :"South of Market Child Care, Inc. (SOMACC)",
    myReviews:"My Reviews",
    myFavoriteNonprofits:"My Favorite Nonprofits",
    myCausePreferences:"My Cause Preferences",
    myDonations:"My Donations",
    manageAccount:"Manage Account",
    editProfile:"Edit Profile",
    editNonprofitProfileBtn:"Edit Nonprofit Profile",
    showOffYourReviews:"Show Off Your Reviews",
    nonProfitMediaGallery:"'Voterwatch' Manage Photos and Videos",
    profile:"Profile",
    manageMyNonprofitStats:"Voterwatch",
    donationsReceived:"Donations Received",
    adminPanel:"Admin Panel",
    signupTitle:"Why you'll love GreatNonprofits",
    inspireInform:"Inspire and inform prospective donors and volunteers",
    inspireInformText:"Help them differentiate between nonprofits, find ones that they trust, and to encourage your community to be more confident in giving or signing up to volunteer.",
    loyalSupporters:"Amplify the impact of loyal supporters",
    loyalSupportersText:"GreatNonprofits Fundraisers give your supporters a simple and powerful way to raise money for their favorite nonprofit.",
    theOpportunity:"GreatNonprofits’ platform gave Elliott Advocacy a simple, user-friendly way to capture user feedback and demonstrate its effectiveness. At the conclusion of cases, the nonprofit incorporated the review process into its workflow by inviting clients to provide feedback. This lent both transparency and trustworthiness to the organization, both highly important factors for a nonprofit focused on consumer advocacy.",
    theOutcome:"Over the past five years, Elliott Advocacy has received nearly 400 reviews and 17k page views on GreatNonprofits. Elliott says the exposure on GreatNonprofits has contributed to a rise in cases over the years. The nonprofit's cases grow by about 10 percent year over year, on average.",
    theNeed:"Founded in 2018 as an outgrowth of advocacy journalism, Elliott Advocacy needed a platform where individuals could provide their thoughts on the performance of the organization. Being a newly established entity, the nonprofit wanted to not only uncover opportunities for growth, but also to showcase its achievements through the firsthand accounts of beneficiaries who received its services.",
    ourStoryBadge:"In this era of social media, millions of people already have discovered that a review by someone who has gone to a restaurant or tried out a doctor is a useful way to evaluate the suitability of those services for themselves.",
    shareStoryWith:"Now you can share your stories about over 1.4 million nonprofits directly on our website, or -- via syndication -- on our partner sites, such as JustGive, GuideStar, and GlobalGiving.",
    greatNonprofitsAndFoundant:"GreatNonprofits & Foundant",
    searchBlogs:"Search Blogs",
    recentPostsLabel:"Recent Posts",
    supportersTitle:"Supporters of GreatNonprofits",
    requestApiInformationText:"As part of this partnership you can integrate reviews directly onto your website or social media properties. Choose from three easy-to-implement solutions: API, embedded widgets, or white label pages. Our rich multimedia offering allows you to include photos, videos, and more -- which adds a new vividness to reviews. Your users can filter review content, and read and write reviews directly from your website.",
    noJobOpening:"No job opening at the moment.",
    noSearch:(orgName:string)=>`No Results ${"For "+orgName}`,

    donateNumberTitle:"OUR IMPACT IN NUMBERS",
    donationMakeDifference:"HOW YOUR DONATION MAKES A DIFFERENCE",
    supportMission:"SUPPORT OUR MISSION",
    supportMissionDescription:"Help us enable great nonprofits to harness their most authentic and most effective advertising — stories submitted by people who know them best — their clients, donors, volunteers, and others — all those who have experienced the impact of nonprofit work up close",
    donationBadge:"DONATIONS TO GREATNONPROFITS ARE TAX-DEDUCTIBLE",
    donationUsQuote:"They are incredibly helpful and responsive to nonprofits' needs and requests and provide a beautiful platform for nonprofits like us to share our important work and shine a spotlight on the needs we address to make the world a better place. Thank you for creating a space to amplify good!",
    faqHelp:"How can we help?",
    helpTagline:"Use our support center to get the most out of GreatNonprofits.",
    donationDescription:"Donations are made to PayPal Giving Fund, a 501(c)(3) charity, and is subject to PayPal Giving Fund’s policies and terms of service for donors. PPGF receives the donation, which is typically tax deductible, net of payment processing fees of 1.99% + $0.49. GreatNonprofits does not profit from these charges, and the total fees are among the lowest donation processing fees for similar services. PayPal Giving Fund typically grants funds to recommended charities within 15-45 days.",
    copyInviteText:"Copy the texts below, and use them in your emails and social media to invite reviews.",
    sendEmails:"Send Emails",
    yourOrganization:"Your Organization",
    yourMedia:"Your Media",
    fileLimit2MB:"File Size Must be Less Than 2MB.",
    yourImpact:"Your Impact",
    moreCities:"More Cities",
    moreCauses:"More Causes",
    more:"More",
    terms:"Terms",
    privacy:"Privacy",
    versionText: (year:any) => `@ ${year} GreatNonprofits. GreatNonprofits is a 501(c)3 nonprofit.`,
    pollsLabel:"Polls",
    voteBtn:"Vote",
    viewResultsBtn:"View Results",
    views:"Views",
    postedBy:"Posted by GreatNonprofits on ",
    zipCodeLabel:"Zip Code",
    individualOrganizationLabel:"Individual / Organization",
    awesomeTitle:"Awesome!",
    readBlogBtn:"Read Blog",
    topRatedNonprofitsBtn:"Top-Rated Nonprofits",
    LatestNewSubmitDescription:"You are signed up to get inspiration, Tips and suggestions on doing good and feeling great!",
    topFoodNonprofitsBtn:"Top Food Nonprofits",
    searchNonprofits: (place:string) => `${place} Nonprofits`,
    searchNonprofitsCity: (place:any) => `${place} Nonprofits and Charities`,
    searchNonprofitsCityState: (place:any) => `Nonprofits in ${place}`,
    hotTopicLabel:"Hot Topics",
    viewAllCities:"View All Cities",
    viewByState:"View by State",
    browseByStateAndCity:"Browse by State and City",
    backToWebsite:"Back to Website",
    termsOfService:"Terms of Service",
    privacyPolicy:"Privacy Policy",
    allCampaign:"All Campaigns",
    allIssues:"All Issues",
    everywhere:"Everywhere",
    list:"list",
    giveWithHeartAndHead:"Give With Your Heart And Your Head",
    donateTopRatedNonprofitToday:"Donate to a Top-Rated Nonprofit Today",
    viewAllTopRatedNonProfit:"View All Top-Rated Nonprofit Today",
    tipsForHolidayGiving:"Tips for Holiday Giving",
    learnMoreBtn:"Learn More",
    areYouNonprofit:"Are you a NonProfit?",
    areYouNonprofitDescription:"Get visibility and free tools for your nonprofit today!",
    shareYourStory:"Share Your Story",
    readStories:"Read Stories",
    supportOneWarmCoat:"Support One Warm Coat",
    supportOneWarmCoatDescription:"Please select the amount you wish to donate from the options provided.",
    usd:"USD",
    donatingTo: (camp:string) => `You are Donating to ${camp}`,
    communityStories:"Community Stories",
    communityStoriesCount: (count:number) => `${count} Stories from Volunteers, Donors & Supporters`,
    nonprofitOverview:"Nonprofit Overview",
    getBadgeBtn:"Get Badge",
    facebook:"Facebook",
    twitter:"Twitter",
    addToFavBtn:"Add to Favorites",
    claimThisNonprofitBtn:"Claim This Nonprofit",
    NonprofitsCharitiesTitle:"Nonprofits and Charities in Other Cities",
    greatNonprofitText:"GreatNonprofits is the leading platform for community-sourced stories about nonprofits",
    greatNonprofitDetailText:"  These stories are submitted by people who know you best -- your clients, donors, volunteers, and others -- all those who have experienced the impact of nonprofit work up close!",
    greatNonprofitButton:"Nonprofits, Get Started",
    aboutGreatNonprofitHeadline:"We enable great nonprofits to harness their most authentic and most effective advertising",
    aboutGreatNonprofitDetail:"These stories are submitted by people who know you best — your clients, donors, volunteers, and others — all those who have experienced the impact of nonprofit work up close!",
    inspireDonor:"Inspiring and Informing Donors",
    inspireDonorText:"72% of people say that the presence of a badge increases their likelihood of giving.",
    socialMediaInviteText:"Follow us today and learn how you can make a difference!",
    greatNonprofitTeam:" The GreatNonprofits Team ",
    ourBoardMembers:"Our Board Members",
    seeAllBoardMembers:"See All Board Members",
    ourAdvisoryBoard :"Our Advisory Board",
    seeAllAdvisoryBoard:"See All Advisory Board Members",
    projectGrantText:'This project has been made possible in part by grants from:',
    careersVolunteering:"Careers and Volunteering",
    careersDetailText:"GreatNonprofits helps people find meaningful ways to give or volunteer. We are the largest site for stories of people who give and volunteer and have received media coverage in the Wall Street Journal, Economist, USA Today, Newsweek, and the Chronicle of Philanthropy.",
    workWithUs:" Work With Us!",
    inquiryText:" For all inquiries, contact us at ",
    opening:"Opening",
    experience:"Experience",
    numOpenings:"No. of Openings",
    qualification:"Qualification",
    applyNow:"Apply Now",
    customerSupport:"Customer Support",
    contactGreatNonprofits:"Contact GreatNonprofits",
    mostFAQText:"Most Frequently Asked Questions",
    seeAllFAQ:"See All FAQs",
    taxDeductible1:"GreatNonprofits (EIN# 20-5061881) is a 501(3) nonprofit organization. Just like the nonprofits on our site, we rely on the support of corporations, foundations and individuals.",
    taxDeductible2:"GreatNonprofits is accountable to its donors. We will not sell or share your name or personal information with any other entity.",
    endorsementsTestimonials:"Endorsements & Testimonials",
    pressMedia:"Press & Media Coverage",
    pressRelease:"GreatNonprofits Press Releases",
    volunteeringOpportunities:"How do you learn about volunteering opportunities?",
    givingBasketSummaryText:"Your Giving Basket Summary",
    basketSummaryText:"Basket Summary",
    nepalYouth:"Nepal Youth Foundation",
    donateMsg1:"Donate in honor or memory of someone",
    donateMsg2:"Allow GreatNonprofits and PayPal Giving Fund to share your name and email address with your chosen charity",
    donateNowDesc:"You’re donating to PayPal Giving Fund (PPGF), an IRS-registered 501(c)(3) charity, subject to its terms. PPGF receives the donation, which is typically tax deductible, minus payment processing fees of 1.99%+$0.49. PPGF typically grants funds to recommended charities within 15-45 days. In the rare event PPGF can't fund your chosen charity, it will (whenever possible) ask you to recommend another, and grant the funds to a similar charity if you don’t respond.",
    aimHigh:"Aim High",
    donateTipMsg:"Thank you for including a tip",
    chargeFeeMsg:"GreatNonprofits doesn't charge any fees — your entire donation goes to support the charity (minus 3rd party processing fees).",
    donateMsg3:"To keep our site running we rely on small tips from our community. Every dollar helps!",
    summary:"Summary",
    subTotal:"Subtotal",
    tip:"Tip",
    total:"Total",
    relatedArticles:"Related articles",
    helpful:"Did you find it helpful?",
    knowledgeBase:"Knowledge base",
    quickGuide:"Explore for quick answers and how-to guides.",
    faqInstruction:"Everything you need to know on how to join the site and manage your user profile.",
    viewAllArticle:" View all articles",
    recentArticle:"Most recent articles",
    raiseMoneyNonprofit:"Raise Money for Your Nonprofit",
    gatherDonation:"Gather donations directly from your GreatNonprofits profile page",
    howToCheckDonation:"How to Check Your Donations",
    elliottAdvocacyHelp:"Elliott Advocacy Help More Consumers with GreatNonprofits",
    about:"About",
    elliottAdvocacyDesc:"Elliott Advocacy is a 501(c)(3) nonprofit organization that empowers consumers to solve their problems and helps those who can’t. It provides direct advocacy services on behalf of consumers free of charge, for cases where:",
    elliottAdvocacyMsg1:"A company hasn’t fulfilled its contractual obligation to provide a product or service.",
    elliottAdvocacyMsg2:" All efforts to go through normal resolution channels have been exhausted.",
    elliottAdvocacyMsg3:"The advocacy team believes it can successfully mediate a resolution.",
    elliottAdvocacyMsg4:"Elliott Advocacy also offers resources and extensive consumer guides on topics ranging from product returns to travel advice, giving people the tools they need to advocate for themselves.",
    theNeedTitle:"The Need",
    theOpportunityTitle:"The Opportunity",
    theOutcomeTitle:"The Outcome",
    addReviewBadge:"Add a Review Badge to Your Website",
    copyBadgeSnippet:"Copy one of the code snippets below, then paste the code into your website wherever you would like your badge to appear.",
    miniBadge:"Mini Badge",
    topRatedNonprofit:"TOP-RATED NONPROFIT",
    reviewFrom:"Reviews from",
    recentReviews:"Most Recent Reviews",
    advertisingGreatNonprofits:"Advertising with GreatNonprofits",
    advertisingHeadline:"Get in front of thousands of nonprofits & millions of individuals who care about donating and volunteering.",
    advertisingMsg1:"GreatNonprofits offers banner advertising on our website to millions of visitors, targeted with more than 5,500 local and city issue pages and in our monthly newsletters and annual Top-Rated program.",
    advertisingMsg2:"Target users by city or issue to make sure your message is relevant.",
    linkToUsThankYouMsg:"Thank you for choosing to link back to us! We love the idea that you value our service enough to tell others and help our community grow. Together we can help more nonprofits get recognized for their work. Even though we are the #1 source of stories and feedback on nonprofits and we are totally free, we realize there are many organizations who are not aware of the marketing and exposure a presence on GreatNonprofits can bring to their organization. Every day our community of donors, volunteers, and beneficiaries add more great stories about the impact of great nonprofits everywhere.",
    linkToUsThankMsg:"So - THANK YOU - again and please feel free to contact us if you have any inquiries about our logos and branding.",
    usageGuideline:" Usage Guidelines:",
    myNonprofits:"My Nonprofits",
    viewFundraiseDashboard:"View Fundraise Dashboard",
    myGoal:"My Goal",
    WeRaised:"We've Raised",
    weStillNeed:"We Still Need",
    endDate:"End Date",
    daysLeft:"Days Left",
    shareOnFacebook:"Share on Facebook",
    shareOnEmail:"Share on Email",
    shareOnTwitter:"Share on Twitter",
    unpublishFundraiser:"Unpublish Fundraiser",
    viewFundraiser:"View Fundraiser",
    editFundraiser:"Edit Fundraiser",
    reviewFundraiserText:"Review and select any areas to update before you publish your fundraiser.",
    addPhoto:"Add or Upload Photo",
    title:"Title",
    story:"Story",
    role:"Role",
    shareReview:"Share this Review",
    donateThisNonprofit:"Donate to this Nonprofit",
    createFundRaiser: "Create Fundraiser",
    unPublish:"Unpublish",
    causePreferenceText:"Help us customize your experience. We want you to tell us what type of content and information you would like to receive about nonprofits!",
    mediaGallery:"Media Gallery",
    nonprofitStats:"Nonprofit Stats",
    topRatedStatus:"Top-Rated Status",
    saveChanges:"Save Changes",
    website:"Website",
    zip:"Zip",
    state:"State",
    city:"City",
    streetAddress:"Street Address",
    name:"name",
    uploadYourLogo:"Upload Your Logo",
    browse:"Browse",
    add:"Add",
    uploadVideoNonprofit:"Upload Videos of Your Nonprofit",
    uploadPhotosNonprofit:"Upload Photos of Your Nonprofit",
    weWorkIn:"We Work In",
    toHelp:"To Help",
    providingPrograms:"By Providing Programs Such as",
    directlyHelped:"Last Year, We Directly Helped",
    directLinkWebsite :"Enable Direct Link to Your Website Donation Page",
    websiteDonateButton:"Website address for Donate button",
    volunteerLink:"Enable direct link to your website volunteer page",
    someoneVolunteer:"Someone who had 3 hours to volunteer could",
    downloadReport:"Download Report",
    topRatedBadgeBtn:"Earn The Top-Rated Badge",
    learnHowToQualify:"Learn How to Qualify",
    learnHowToNominate:"Learn How to Nominate",
    specialThanksSponsors:"Special Thanks to Our Sponsors",
    downloadDocxTemplate:"Download a .docx template",
    becomeTopRatedNonproofit:"Become a Top-Rated Nonprofit",
    nonprofits:"Nonprofits",
    volunteersDonorsSupporters:"Volunteers, Donors, Supporters",
    inviteReviewsClientVolunteersDonors:"Invite Reviews From Your Clients, Volunteers and Donors",
    easilyLargerAudienceToday:"Easily Reach a Larger Audience Today",
    boostDonorTrustAndConfidence:"Boost Donor Trust and Confidence",
    testimonials:"Testimonials",
    collectDonationsGreatNonprofits:"Collect Donations Through GreatNonprofits",
    getRecognitionToday:"Get Recognition Today",
    inviteReviewSMS:"Invite Reviews with SMS",
    topRatedBadgeText:"The Top-Rated Badge",
    statistics:"Statistics",
    gainMoreExposureReviewSyndication:"Gain More Exposure with Review Syndication",
    boostTrustAndConfidence:"Boost Trust and Confidence",
    starBadge:"Star Badge",
    getRecognitionShowOffTopRatedStatus:"Get Recognition. Show Off Your Top-Rated Status",
    featuredSuccessStories:"Featured Success Stories",
    peopleServed:"People Served",
    funders:"Funders",
    clients:"Clients",
    partnerSolutions:"Partner Solutions",
    statisticsOnDonation:"Statistics on Donation",
    reviewsFrom:"Reviews From",
    addLogoBadgeWebsite:"Add a Logo Badge to Your Website",
    downloadYourReviewArchive:"Download Your Review Archive",
    addReviewBadgeWebsite:"Add a Review Badge to Your Website",
    photosVideos:"Photos & Videos",
    averageRatings:"Average Ratings",
    improveProfile :"Improve Your Profile",
    addPhotos:"Add a Photo",
    nonprofitsStats:"Your Nonprofits Stats",
    latestReviewed:"Latest Reviewed",
    followers:"Followers",
    pageViews:"Page Views",
    topRatedAwardsStats:"Your Top Rated Awards Stats",
    learnAboutTopRatedAwards:"Learn more about the Top-Rated Awards",
    profileCompletion:"Profile Completion",
    uploadPhoto:"Upload a Photo",
    postFacebookTwitter: "Post to Facebook and Twitter",
    giveagain:"Give Again"
};